import locationStorageAdapter from '../services/adapters/locationStorage.adapter';
import { storageConstant } from '../constants/storage.constant';
import { useAppSelector } from './useAppSelector.hook';
import { getKCUser, setIsLogged, getDispatchModal } from '../redux/App/App.slice';
import { keycloak } from '../keycloak';
import { useAppDispatch } from './useAppDispatcher.hook';
import { ErrorModalTypes } from '../constants/error.constant';

const { ACCESS_TOKEN, REFRESH_TOKEN } = storageConstant;

const useAuthHook = () => {
  const user = useAppSelector(getKCUser);
  const dispatchModal = useAppSelector(getDispatchModal);

  const dispatch = useAppDispatch()

  const removeToken = (tokenName: string): void =>
    locationStorageAdapter.delete(tokenName);

  const removeTokens = (): void => {
    removeToken(ACCESS_TOKEN);
    removeToken(REFRESH_TOKEN);
  }

  const handleLogout = () => {
    return keycloak.logout()
      .then(() => removeTokens())
      .then(() => dispatch(setIsLogged(false)))
      .then(() => window.location.reload());
  }

  return {
    user,
    handleLogout,
    hasAccessError: [ErrorModalTypes.FORBIDDEN, ErrorModalTypes.NO_ACCESS].includes(dispatchModal?.type),
  };
};

export default useAuthHook;
